import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function NCIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      titleAccess="NC">
      <path
        d="M3.8 4.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V7.6c0-1.7 1.4-3 3-3z"
        fill="#0a4842"
      />
      <path
        d="M3.8 4.6h22.3c1.7 0 3 1.3 3 3v13.8c0 1.7-1.3 3-3 3H3.8c-1.7 0-3-1.3-3-3V7.6c0-1.7 1.4-3 3-3z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M9.5 18.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.5c.4 0 .7.2.8.5l2.1 4v-3.9c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.5c.2 0 .3.1.4.2.1.1.2.2.2.4V18c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.4 0-.7-.2-.8-.5l-2.1-4V18c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5zm9.7.1c-1.1 0-2-.3-2.6-1-.6-.6-.9-1.6-.9-2.8 0-1.2.3-2.1.9-2.8.6-.7 1.5-1 2.5-1 .5 0 1 0 1.4.1.2 0 .3.1.4.2.1.3.1.4.1.6v.3c0 .1-.1.2-.2.3-.1.1-.2.1-.4.1-.4-.1-.8-.1-1.2-.1-.6 0-1.1.2-1.4.6-.3.4-.5 1-.5 1.8s.2 1.4.5 1.8c.4.4.8.6 1.4.6.4 0 .8 0 1.2-.1.1 0 .3 0 .4.1.1.1.2.2.2.3v.3c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2s-.7.1-1.2.1z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
